export type menu = MenuItem[]

export enum MenuItemType {
  PARENT = 'PARENT',
  GROUP = 'GROUP',
  DEFAULT = 'DEFAULT',
  BUTTON = 'BUTTON',
}

export enum TargetType {
  SELF = 'SELF',
  BLANK = 'BLANK',
}

export type MenuItem = {
  type: MenuItemType
  title: string
  description?: string
  url?: string
  target?: TargetType
  children?: MenuItem[]
}

const NormalMenuItem: MenuItem = {
  type: MenuItemType.DEFAULT,
  title: 'Individual Courses',
  url: 'https://www.google.com',
  target: TargetType.SELF,
}

const ButtonMenuItem: MenuItem = {
  type: MenuItemType.BUTTON,
  title: 'See All',
  url: 'https://www.google.com',
  target: TargetType.SELF,
}
const GroupMenuItem = {
  type: MenuItemType.GROUP,
  title: 'Course Types',
  children: [
    NormalMenuItem,
    NormalMenuItem,
    NormalMenuItem,
    NormalMenuItem,
    ButtonMenuItem,
  ],
}

const TitleMenuItem: MenuItem = {
  type: MenuItemType.DEFAULT,
  title: 'Courses Home',
  url: 'https://www.google.com',
  target: TargetType.BLANK,
}

const GroupMenuItems: MenuItem[] = [
  TitleMenuItem,
  GroupMenuItem,
  GroupMenuItem,
  GroupMenuItem,
]

const exploreMenuItem: MenuItem = {
  type: MenuItemType.PARENT,
  title: 'Explore',
  children: [
    {
      type: MenuItemType.PARENT,
      title: 'Courses',
      description:
        'Individual courses, certificate programs, and master programs',
      children: GroupMenuItems,
    },
    {
      type: MenuItemType.PARENT,
      title: 'Certifications',
      description: 'Official APTD and CPTD (formerly CPLP) credentials',
      children: GroupMenuItems,
    },
    {
      type: MenuItemType.PARENT,
      title: 'Conferences',
      description: 'US conferences and global events',
      children: GroupMenuItems,
    },
    {
      type: MenuItemType.PARENT,
      title: 'Read',
      description: 'Articles, magazines, books, and more',
      children: GroupMenuItems,
    },
    {
      type: MenuItemType.PARENT,
      title: 'Watch/Listen',
      description: 'Videos, Webinars, and Podcasts',
      children: GroupMenuItems,
    },
    {
      type: MenuItemType.PARENT,
      title: 'Topics',
      children: GroupMenuItems,
    },
  ],
}

const membershipMenuItem: MenuItem = {
  type: MenuItemType.PARENT,
  title: 'Membership',
  children: [
    {
      type: MenuItemType.DEFAULT,
      title: 'Join/Renew',
      url: 'https://www.google.com',
      target: TargetType.BLANK,
    },
    {
      type: MenuItemType.DEFAULT,
      title: 'Why Join',
      url: 'https://www.google.com',
      target: TargetType.BLANK,
    },
    {
      type: MenuItemType.DEFAULT,
      title: 'Join A Chapter',
      url: 'https://www.google.com',
      target: TargetType.BLANK,
    },
    {
      type: MenuItemType.DEFAULT,
      title: 'Member Groups',
      url: 'https://www.google.com',
      target: TargetType.BLANK,
    },
    {
      type: MenuItemType.DEFAULT,
      title: 'Member Forums',
      url: 'https://www.google.com',
      target: TargetType.BLANK,
    },
  ],
}

const resourcesMenuItem: MenuItem = {
  type: MenuItemType.PARENT,
  title: 'Resources',
  children: [
    {
      type: MenuItemType.DEFAULT,
      title: 'Capatibility Model',
      url: 'https://www.google.com',
      target: TargetType.BLANK,
    },
    {
      type: MenuItemType.DEFAULT,
      title: 'ATD Job Bank',
      url: 'https://www.google.com',
      target: TargetType.BLANK,
    },
    {
      type: MenuItemType.DEFAULT,
      title: 'L&D Degree Directory',
      url: 'https://www.google.com',
      target: TargetType.BLANK,
    },
    {
      type: MenuItemType.DEFAULT,
      title: 'Vendor Directory',
      url: 'https://www.google.com',
      target: TargetType.BLANK,
    },
    {
      type: MenuItemType.DEFAULT,
      title: 'TD at Work Guides',
      url: 'https://www.google.com',
      target: TargetType.BLANK,
    },
    {
      type: MenuItemType.DEFAULT,
      title: 'Tools & Templates',
      url: 'https://www.google.com',
      target: TargetType.BLANK,
    },
  ],
}

const aboutMenuItem: MenuItem = {
  type: MenuItemType.PARENT,
  title: 'About ATD',
  children: [
    {
      type: MenuItemType.DEFAULT,
      title: 'About ATD',
      url: 'https://www.google.com',
      target: TargetType.BLANK,
    },
    {
      type: MenuItemType.DEFAULT,
      title: 'Help Center',
      url: 'https://www.google.com',
      target: TargetType.BLANK,
    },
  ],
}

export const rootMenu: MenuItem[] = [
  exploreMenuItem,
  membershipMenuItem,
  resourcesMenuItem,
  aboutMenuItem,
  // rootMenuItem,
]
// console.log(JSON.stringify(rootMenu))

export default rootMenu
